import React, { useEffect, useState } from 'react';
import Navbar from "../components/Navbar";
import Footer from '../components/Footer';
import PageHeader from "../components/PageHeader";
import BackToTop from '../components/BackToTop';
import '../css/gallery.css';
import imgFallback from '../assets/carousel-1.jpg';
import headerBg from '../assets/background-4.jpg';
import { getItems } from '../utils/collectionStorage';

export default function ImageCollectionPage({ title, path, collection, bgImage }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [imageLoading, setImageLoading] = useState({});

  useEffect(() => {
    const load = async () => {
      try {
        console.log(`Loading collection: ${collection}`);
        const data = await getItems(collection);
        console.log(`Loaded ${data.length} items for ${collection}`);
        setItems(data);
        // Initialize image loading state
        const loadingState = {};
        data.forEach(item => {
          loadingState[item.id] = true;
        });
        setImageLoading(loadingState);
      } catch (e) {
        console.error(`Error loading ${collection}:`, e);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [collection]);

  const handleImageLoad = (itemId) => {
    setImageLoading(prev => ({
      ...prev,
      [itemId]: false
    }));
  };

  const handleImageError = (itemId) => {
    setImageLoading(prev => ({
      ...prev,
      [itemId]: false
    }));
  };

  return (
    <>
      <Navbar />
      <PageHeader title={title} path={path} name={title} bgImage={bgImage || headerBg} />
      <div className="gallery-page container-xxl py-5">
        <div className="container">
          <div className="gallery-intro">
            <h1>{title}</h1>
          </div>
          {loading ? (
            <div style={{textAlign: 'center', padding: '50px'}}>
              <i className="fa fa-spinner fa-spin" style={{fontSize: '2rem', color: '#002147'}}></i>
            </div>
          ) : (
            <div className="gallery-grid">
              {items.map((item) => (
                <div className="gallery-item" key={item.id}>
                  {imageLoading[item.id] && (
                    <div style={{position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', zIndex: 1}}>
                      <i className="fa fa-spinner fa-spin" style={{fontSize: '1.5rem', color: '#002147'}}></i>
                    </div>
                  )}
                  <img 
                    src={item.img} 
                    alt={item.title} 
                    onLoad={() => handleImageLoad(item.id)}
                    onError={(e) => { 
                      e.target.onerror = null; 
                      e.target.src = imgFallback; 
                      handleImageError(item.id);
                    }}
                    style={{opacity: imageLoading[item.id] ? 0 : 1, transition: 'opacity 0.3s ease'}}
                  />
                  <div className="collection-caption">
                    {item.title && <h4>{item.title}</h4>}
                    {item.content && <p style={{margin: 0, color: '#64748b'}}>{item.content}</p>}
                  </div>
                </div>
              ))}
              {items.length === 0 && (
                <div style={{textAlign: 'center', padding: '50px', color: '#64748b'}}>
                  <i className="fa fa-image" style={{fontSize: '3rem', marginBottom: '20px', display: 'block'}}></i>
                  <h3>No {title.toLowerCase()} uploaded yet</h3>
                  <p>Please check back later or contact the administrator.</p>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
      <Footer />
      <BackToTop />
    </>
  );
}
